import { useState, useEffect, useRef, useCallback } from 'react';
import io from 'socket.io-client';

// Use your production URL for the WebSocket connection
const API_URL = process.env.REACT_APP_API_URL || 'https://madurai-backend.onrender.com';

export const useSocket = (userId) => {
    const [isOrderUpdated, setIsOrderUpdated] = useState(false);
    const socketRef = useRef(null);

    // A function for the context to call after it has refetched the data
    const resetOrderUpdateFlag = useCallback(() => {
        setIsOrderUpdated(false);
    }, []);

    useEffect(() => {
        // Only connect if a userId is provided
        if (!userId) {
            // If there's an existing connection but no user, disconnect it
            if (socketRef.current) {
                socketRef.current.disconnect();
                socketRef.current = null;
            }
            return;
        }

        // If there is no current connection, create one
        if (!socketRef.current) {
            // Establish connection to the server's root URL
            socketRef.current = io(API_URL);

            socketRef.current.on('connect', () => {
                 console.log('Socket connected:', socketRef.current.id);
                // Join a room specific to this user to receive their order updates
                socketRef.current.emit('join_room', userId);
            });

            // This function will run when the vendor updates an order
            const handleOrderUpdate = (updatedOrder) => {
                console.log('An order was updated by the vendor:', updatedOrder);
                setIsOrderUpdated(true); // Set a flag to trigger a data refresh
            };

            // Listen for the two types of update events from the server
            socketRef.current.on('order_status_update', handleOrderUpdate);
            socketRef.current.on('new_order', handleOrderUpdate);

            socketRef.current.on('disconnect', () => {
                 console.log('Socket disconnected');
            });
        }

        // Cleanup function to disconnect the socket when the component unmounts
        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
                socketRef.current = null;
            }
        };
    }, [userId]); // Re-run the effect if the userId changes

    return { isOrderUpdated, resetOrderUpdateFlag };
};

